import { createWebHistory, createRouter } from "vue-router";

//import Home from "@/components/HelloWorld.vue";
import HomeScreen from '@/components/HomeScreen.vue';
import RegisterScreen from '@/components/RegisterScreen.vue';
import LoginScreen from '@/components/LoginScreen.vue';
import DashboardScreen from '@/components/DashboardScreen.vue';
import ProfileScreen from '@/components/ProfileScreen.vue';
import AboutScreen from "@/components/AboutScreen.vue";
import SplashScreen from "@/components/SplashScreen.vue";
import NotFound from "@/components/NotFound.vue";
import FastApi from "@/components/FastApi.vue";
import OllamaScreen from "@/components/OllamaScreen.vue";
import SystemScreen from '@/components/SystemScreen';
import Settings from '@/components/SettingsScreen';
import Charts from '@/components/ChartsScreen';
import Analyzer from '@/components/AnalyzerScreen';
import Calendar from '@/components/CalendarScreen';
import VacationChecklistScreen from '@/components/VacationChecklistScreen';
import StocksScreen from '@/components/StocksScreen';
import AlbenScreen from '@/components/AlbenScreen';
import RankingScreen from '@/components/RankingScreen';
import ArticlesScreen from '@/components/ArticlesScreen';
import AktivitiesScreen from '@/components/ActivitiesScreen';
import ImageUploadScreen from '@/components/ImageUploadScreen';
import SharedImageView from '@/components/SharedImageView';
import SharedTransactionPdfView from '@/components/SharedTransactionPdfView';
import SharedTransactionCsvView from '@/components/SharedTransactionCsvView';
import TrainObjectsScreen from '@/components/TrainObjectsScreen';
import TracksScreen from '@/components/TracksScreen';
import TracksClusterScreen from '@/components/TracksClusterScreen';
import TransactionScreen from '@/components/TransactionScreen';
import HealthDashboardScreen from '@/components/HealthDashboardScreen';
import HealthScorecardScreen from '@/components/HealthScorecardScreen';
import PortfolioDashboardScreen from '@/components/PortfolioDashboardScreen';
import TradingDashboardScreen from '@/components/TradingDashboardScreen';

import store from '@/store';
import { isShoppingHost, isMainAppHost, getShoppingOrigin, getMainAppOrigin } from '@/config/appHosts';

const routes = [
    {
      path: '/shopping/login',
      name: 'ShoppingLogin',
      component: LoginScreen,
      meta: { shoppingLayout: true },
    },
    { path: '/shopping', strict: true, redirect: to => ({ path: isShoppingHost() ? '/' : '/shopping/', query: to.query, hash: to.hash }) },
    {
      path: '/shopping/',
      name: 'ShoppingOverview',
      beforeEnter: to => isShoppingHost() ? { path: '/', query: to.query, hash: to.hash } : true,
      component: () => import('@/components/ShoppingScreen.vue'),
      meta: { requiresAuth: true, shoppingLayout: true },
    },
    {
      path: '/shopping/:listId',
      name: 'Shopping',
      component: () => import('@/components/ShoppingScreen.vue'),
      meta: { requiresAuth: true, shoppingLayout: true },
    },
    {
    path: '/einkommen',
    name: 'IncomeDashboard',
    component: () => import('@/components/IncomeDashboardScreen.vue'),
    meta: { requiresAuth: true },
    },
    {
    path: '/abfindung',
    name: 'SeveranceSimulation',
    component: () => import('@/components/SeveranceSimulationScreen.vue'),
    meta: { requiresAuth: true },
    },
    {
    path: '/vermoegen',
    name: 'WealthDashboard',
    component: () => import('@/components/WealthDashboardScreen.vue'),
    meta: { requiresAuth: true },
    },
    {
    path: "/",
    name: "HomeRoot",
    component: isShoppingHost() ? () => import('@/components/ShoppingScreen.vue') : HomeScreen,
    meta: isShoppingHost() ? { requiresAuth: true, shoppingLayout: true } : {},
    },
    {
    path: "/splash",
    name: "Splash",
    component: SplashScreen,
    },
    {
    path: "/fastapi",
    name: "FastApi",
    component: FastApi,
    },
    {
    path: "/ollama",
    name: "Ollama",
    component: OllamaScreen,
    meta: {requiresAuth: true},
    },
    {
    path: "/about",
    name: "About",
    component: AboutScreen,
    },
    {
    path: "/home",
    name: "Home",
    component: HomeScreen,
    },
    {
    path: '/register',
    name: 'Register',
    component: RegisterScreen,
    },
    {
    path: '/login',
    name: 'Login',
    component: LoginScreen,
    },
    {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/stocks',
    name: 'Stocks',
    component: StocksScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/tracks2',
    name: "Tracks2",
    component: TracksScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/trackscluster',
    name: "TracksCluster",
    component: TracksClusterScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/health',
    name: "HealthDashboard",
    component: HealthDashboardScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/healthscorecard',
    name: "HealthScorecard",
    component: HealthScorecardScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/portfolio',
    name: "PortfolioDashboardScreen",
    component: PortfolioDashboardScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/trading',
    name: "TradingDashboardScreen",
    component: TradingDashboardScreen,
    meta: {requiresAuth: true},
    },
    {
      path: '/tracks/:aktivitaten_activityId',
      name: 'Tracks',
      component: TracksScreen,
      meta: {requiresAuth: true},
    },
    {
      path: '/analyzer/:idstocks?/:stocks_name?',
      name: 'Analyzer',
      component: Analyzer,
      meta: { requiresAuth: true },
    },
    {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {requiresAuth: true},
    },
    {
    path: '/vacation-checklist',
    name: 'VacationChecklist',
    component: VacationChecklistScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/activities',
    name: 'Activities',
    component: AktivitiesScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/transactions',
    name: 'Transactions',
    component: TransactionScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/transactions/:idstocks',
    name: 'TransactionsWithIdstocks',
    component: Analyzer,
    meta: {requiresAuth: true},
    },
    {
    path: '/alben',
    name: 'Alben',
    component: AlbenScreen,
    meta: {requiresAuth: true},
    },
    {
      path: '/imageupload',
      name: 'ImageUpload',
      component: ImageUploadScreen,
      meta: {requiresAuth: true},
    },
    {
      path: '/shared',
      name: 'SharedImage',
      component: SharedImageView,
      meta: {requiresAuth: true},
    },
    {
      path: '/shared-transaction-pdf',
      name: 'SharedTransactionPdf',
      component: SharedTransactionPdfView,
      meta: {requiresAuth: true},
    },
    {
      path: '/shared-transaction-csv',
      name: 'SharedTransactionCsv',
      component: SharedTransactionCsvView,
      meta: {requiresAuth: true},
    },
    {
    path: '/rankings',
    name: 'Rankings',
    component: RankingScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/articles',
    name: 'Articles',
    component: ArticlesScreen,
    meta: {requiresAuth: true},
    },
    {
    path: '/profile',
    name: 'Profile',
    component: ProfileScreen,
    meta: {requiresAuth: true},
    },
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings,
      meta: {requiresAuth: true},
    },
    {
      path: '/System',
      name: 'System',
      component: SystemScreen,
      meta: {requiresAuth: true},
    },
    {
      path: '/Charts',
      name: 'Charts',
      component: Charts,
      meta: {requiresAuth: true},
    },
    {
      path: '/TrainObjects',
      name: 'TrainObjects',
      component: TrainObjectsScreen,
      meta: {requiresAuth: true},
    },
    {
      path: "/:catchAll(.*)",
      component: NotFound,
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to, _from, failure) => {
  if (!failure) window.updateAppPwa?.(to.fullPath);
});

//verify if users is allowed in Navigation Guard
router.beforeEach(async (to) => {
  if (isMainAppHost() && /^\/shopping(?:\/|$)/.test(to.path) && to.query.legacy !== '1') {
    window.location.assign(new URL(to.fullPath, getShoppingOrigin()).href);
    return false;
  }
  if (isShoppingHost() && !to.meta.shoppingLayout) {
    // Main-app links leave the Shopping origin so its PWA identity stays stable.
    const mainOrigin = getMainAppOrigin();
    if (!mainOrigin) return { path: '/' };
    window.location.assign(new URL(to.fullPath, mainOrigin).href);
    return false;
  }
  if (!store.getters.isAuthInitialized) {
    await store.dispatch('initializeAuth');
  }

  if (to.path === '/' && to.query.sharedTransactionPdf) {
    return {
      name: 'SharedTransactionPdf',
      query: { shareId: to.query.sharedTransactionPdf },
    };
  }

  if (to.path === '/' && to.query.sharedTransactionCsv) {
    return {
      name: 'SharedTransactionCsv',
      query: { shareId: to.query.sharedTransactionCsv },
    };
  }

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return true;
  }

  if (store.getters.isAuthenticated) {
    console.log('Auth ok')
    return true;
  }

  console.log('!! Auth NOT ok')
  //zwischenspeichern der Ziel - Einstiegsseite oder auf die Startseite aus Settings?
  //wenn zwischenspeichern, dann in settings speichern und im Login dort abrufen und starten
  //obj.emitter.emit("Zielseite", { msg: to });
  return {
    path: to.meta.shoppingLayout ? '/shopping/login' : '/login',
    query: to.fullPath && to.fullPath !== '/login' ? { redirect: to.fullPath } : {},
  };
});


export default router;
